import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { ruDate } from '../userCardFormat';
import { parseTelegramHtml } from './telegramHtml';
import t from './TelegramPreview.module.css';
/** Covered until clicked, as in Telegram. */
function Spoiler({ children }) {
    const [open, setOpen] = useState(false);
    if (open)
        return (_jsx("span", { className: t.spoiler, "data-open": true, children: children }));
    return (_jsx("span", { className: t.spoiler, role: "button", tabIndex: 0, "aria-label": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043F\u043E\u0439\u043B\u0435\u0440", onClick: () => setOpen(true), onKeyDown: (e) => {
            if (e.key !== 'Enter' && e.key !== ' ')
                return;
            e.preventDefault();
            setOpen(true);
        }, children: children }));
}
/** The parsed text as elements — never as raw HTML. */
function draw(nodes) {
    return nodes.map((n, i) => {
        if (n.type === 'text')
            return _jsx(Fragment, { children: n.text }, i);
        const kids = draw(n.children);
        switch (n.tag) {
            case 'b':
                return _jsx("b", { children: kids }, i);
            case 'i':
                return _jsx("i", { children: kids }, i);
            case 'u':
                return _jsx("u", { children: kids }, i);
            case 's':
                return _jsx("s", { children: kids }, i);
            case 'code':
                return _jsx("code", { children: kids }, i);
            case 'pre':
                return _jsx("pre", { children: kids }, i);
            case 'blockquote':
                return (_jsx("blockquote", { "data-expandable": n.expandable || undefined, children: kids }, i));
            case 'spoiler':
                return _jsx(Spoiler, { children: kids }, i);
            case 'a':
                return n.href ? (_jsx("a", { href: n.href, target: "_blank", rel: "noreferrer", children: kids }, i)) : (_jsx(Fragment, { children: kids }, i));
        }
    });
}
/**
 * One language of the mailing as a Telegram message: the media, the text, the
 * gift line the bot adds, then the gift button and the link buttons. The letter
 * gets only a subject line here — its template lives on the server.
 */
export function TelegramPreview({ translation, media, gift, email, }) {
    const nodes = translation ? parseTelegramHtml(translation.text.trim()).nodes : [];
    const buttons = translation?.buttons ?? [];
    const lang = translation?.language ?? 'ru';
    return (_jsxs("section", { className: t.preview, "aria-label": "\u041A\u0430\u043A \u0432 Telegram", children: [_jsxs("h3", { className: t.caption, children: ["\u041A\u0430\u043A \u0432 Telegram \u00B7 ", lang] }), _jsxs("div", { className: t.chat, children: [_jsxs("div", { className: t.bubble, children: [media &&
                                (media.media_type === 'video' ? (_jsx("video", { className: t.media, src: media.url, muted: true, loop: true, playsInline: true, autoPlay: true, "aria-label": "\u0412\u0438\u0434\u0435\u043E \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438" })) : (_jsx("img", { className: t.media, src: media.url, alt: "\u041C\u0435\u0434\u0438\u0430 \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438" }))), _jsxs("div", { className: t.text, children: [nodes.length > 0 ? draw(nodes) : _jsx("span", { className: t.empty, children: "\u0422\u0435\u043A\u0441\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F" }), gift && (_jsxs("span", { className: t.giftLine, children: ['\n\n', "*\u041F\u043E\u0434\u0430\u0440\u043E\u043A \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E: ", ruDate(gift.expires_on)] }))] })] }), (gift || buttons.length > 0) && (_jsxs("div", { className: t.keyboard, children: [gift && (_jsx("span", { className: t.key, children: translation?.giftButton.trim() || 'Кнопка подарка' })), buttons.map((b, i) => (_jsxs("span", { className: t.key, children: [b.text.trim() || 'Кнопка', _jsx("span", { className: t.keyLink, "aria-hidden": "true", children: "\u2197" })] }, i)))] }))] }), email && _jsxs("p", { className: t.mail, children: ["\u041F\u0438\u0441\u044C\u043C\u043E: ", translation?.subject.trim() || 'без темы'] }), gift && lang !== 'ru' && (_jsx("p", { className: t.note, children: "\u041F\u043E\u0434\u043F\u0438\u0441\u044C \u043F\u043E\u0434\u0430\u0440\u043A\u0430 \u0431\u043E\u0442 \u043D\u0430\u043F\u0438\u0448\u0435\u0442 \u043D\u0430 \u044F\u0437\u044B\u043A\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F" }))] }));
}
